import type { PartnerBenefit } from "../../types/vtc";
import { useT } from "../../i18n";

interface PartnerCtaProps {
  benefits: PartnerBenefit[];
}

export default function PartnerCta({ benefits }: PartnerCtaProps) {
  const t = useT();
  return (
    <section className="bg-ink text-white">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-16 sm:px-6 sm:py-18 lg:grid-cols-2">
        <div>
          <div className="mb-3 text-[13px] text-dim">{t.home.partner.eyebrow}</div>

          <h2 className="m-0 text-3xl font-medium leading-tight text-balance sm:text-4xl lg:text-[42px]">
            {t.home.partner.title}
          </h2>

          <div className="mt-7 flex flex-wrap gap-3">
            <a
              href="/partners/signup"
              className="flex h-10 items-center rounded bg-white px-5.5 text-sm font-medium text-ink no-underline transition-colors hover:bg-[#EDEDED]"
            >
              {t.home.partner.listVehicles}
            </a>
            <a
              href="/pricing"
              className="flex h-10 items-center rounded border border-muted px-5.5 text-sm font-medium text-white no-underline transition-colors hover:bg-white/10"
            >
              {t.home.partner.seePricing}
            </a>
          </div>
        </div>

        <div className="grid gap-4.5">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="flex flex-col gap-1 border-t border-line-dark pt-4.5 sm:flex-row sm:gap-3.5"
            >
              <b className="min-w-37.5 font-medium">{benefit.title}</b>
              <span className="text-[15px] leading-relaxed text-dimmer">
                {benefit.description}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
